'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Word = function Word($resource) {
  'ngInject';

  return $resource('http://jezor.pl/api/words/:rows/:cols');
  // return $resource(`http://localhost/jezor/api/words/:rows/:cols`);
};

exports.default = Word;


// WEBPACK FOOTER //
// ./client/app/components/memo/word.factory.js